/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2GuestProjectsByProjectIdParams,
  PostV2GuestProjectsBody,
  PostV2GuestProjectsResponse,
  GetV2GuestProjectsByProjectIdResponse,
} from '../types';

export class GuestProjects extends Controller {
  async postV2GuestProjects<
    T extends PostV2GuestProjectsResponse,
    D,
    C extends PostV2GuestProjectsBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/guest/projects',
      body,
      axiosConfig
    );
  }

  async getV2GuestProjectsByProjectId<
    T extends GetV2GuestProjectsByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetV2GuestProjectsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/projects/${projectId}`,
      axiosConfig
    );
  }
}
